import { render, staticRenderFns } from "./TenancyDetail.vue?vue&type=template&id=42d523b2&"
import script from "./TenancyDetail.vue?vue&type=script&lang=js&"
export * from "./TenancyDetail.vue?vue&type=script&lang=js&"
import style0 from "./TenancyDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42d523b2')) {
      api.createRecord('42d523b2', component.options)
    } else {
      api.reload('42d523b2', component.options)
    }
    module.hot.accept("./TenancyDetail.vue?vue&type=template&id=42d523b2&", function () {
      api.rerender('42d523b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ccd/TenancyDetail.vue"
export default component.exports